import React, { useState, useEffect } from "react";
import styled from "styled-components";

export type SelectorOption = {
  id: string;
  name: string;
  icon: React.ReactNode;
};

type SelectorMenuProps = {
  options: SelectorOption[];
  defaultSelectedId?: string;
  selectedId?: string;
  onSelect?: (selectedId: string, selectedName: string) => void;
  title?: string;
};

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 15px;
`;

const TitleWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  width: 100%;
`;

const Title = styled.div`
  display: flex;
  align-items: center;
  font-size: 0.785rem;
  font-weight: 500;
  color: var(--font-color);
`;

const MenuWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  justify-content: center;
  width: 100%;

`;

const MenuButton = styled.button<{ selected: boolean }>`
  background-color: ${({ selected }) => (selected ? "var(--primary-color)" : "#ffb87a5c")};
  border: none;
  padding: 6px 14px;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  transition: all 0.2s ease-in-out;
  color: ${({ selected }) => (selected ? "#fff" : "var(--font-color)")};

  &:hover {
    opacity: 0.85;
  }

  svg {
    margin-right: 8px;
    pointer-events: none;
  }

  span {
    font-size: 0.85rem;
  }

  @media (max-width: 768px) {
    width: 45%;
  }
`;

export const SelectorMenu: React.FC<SelectorMenuProps> = ({ options, defaultSelectedId, selectedId: selectedIdProp, onSelect, title }) => {
  const [selectedId, setSelectedId] = useState<string | undefined>(selectedIdProp || defaultSelectedId);

  useEffect(() => {
    if (selectedIdProp !== undefined) {
      setSelectedId(selectedIdProp);
    }
  }, [selectedIdProp]);

  const handleSelect = (id: string, name: string) => {
    if ((id !== selectedId) && (onSelect)) {
      onSelect(id, name);
    }

    setSelectedId(id);
  };

  return (
    <Wrapper>
      <TitleWrapper>
        {title && <Title>{title}:</Title>}
      </TitleWrapper>
      <MenuWrapper>
        {options.map((option) => (
          <MenuButton
            key={option.id}
            selected={selectedId === option.id}
            onClick={() => handleSelect(option.id, option.name)}
          >
            {option.icon}
            <span>{option.name}</span>
          </MenuButton>
        ))}
      </MenuWrapper>
    </Wrapper>
  );
};
